/**
 * Automatically set key in context by renderer in cli.mts and createHtmlTemplate.ts
 * Contains breadcrumbs for current page
 */
export const breadcrumbsContextKey = "breadcrumbs";
